import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const UndoSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default UndoSVG;
